import React from 'react';
import moment from 'moment';
import './CodeSystemItem.css';

function CodeSystemItem({ item, openFunction }) {
	var status_color = '';
	var pill_color = '';

	function handleClick(xx) {
		openFunction(item.id);
	}

	switch (item.status) {
		case 'active':
			status_color = 'status_green';
			pill_color = 'pill pill_green';
			break;
		case 'draft':
			status_color = 'status_amber';
			pill_color = 'pill pill_amber';
			break;
		default:
			status_color = 'status_grey';
			pill_color = 'pill pill_grey';
	}

	const div_style = 'codeSystemItem ' + status_color;
	const date = moment(item.date);
	const versionText = item.version !== undefined ? `v${item.version}` : '';

	if (item.meta.tag !== undefined) {
		var tags = item.meta.tag.filter(
			(x) => x.system === 'http://acme.org/tags/'
		);
		var tagPills = tags.map((x) => (
			<span key={x.code} className="pill pill_blue">
				{x.code}
			</span>
		));
	}

	return (
		<div className={div_style} data={item} onClick={handleClick}>
			<div className="codeSystemItem__left">
				<div className="codeSystemItem__title">
					{item.title}{' '}
					<span className="codeSystemItem__version">{versionText}</span>
				</div>
				<div className="codeSystemItem__url">{item.url}</div>
				<div className="codeSystemItem__tag">{tagPills}</div>
			</div>
			<div className="codeSystemItem__right">
				<div className="codeSystemItem__status">
					<span className={pill_color}>{item.status}</span>
				</div>
				{item.date &&
					<div className="codeSystemItem__date">
						Date : {date.format('DD MMM YYYY')}
					</div>
				}
			</div>
		</div>
	);
}

export default CodeSystemItem;
